// extracted by mini-css-extract-plugin
module.exports = {"wrap":"search-result-skeleton_wrap__31K9E"};